var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content-wrappper" }, [
      _c("div", { staticClass: "col-xs-8 notification_box row" }, [
        _vm._v(
          "You currently do not have permissions to access this section, please contact your Admin."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }